/* eslint-disable sort-keys */
//
// TODO: These token values are stubbed estimated values.
// Full design specs should correct these.
//
//
// Breakpoints are the starting device width as pixels in number form here
//
export const WEB_BREAKPOINT_START_NUMBERS = {
    XS: 0,
    SM: 760,
    MD: 1100,
    LG: 1440,
    XL: 1920, // Large desktop, tv
};
export const NATIVE_BREAKPOINT_START_NUMBERS = {
    SM: 0,
    MD: 360,
    LG: 440, // Large phones and tablets
};
//
// Breakpoints can be seen as minimum or maximum values depending on how you look at it.
// Here we define MIN and MAX values for each breakpiont.
// One breakpoint's MAX is the next breakpoint's MIN - 1.
//
export const WEB_BREAKPOINT = {
    XS_MIN: WEB_BREAKPOINT_START_NUMBERS.XS,
    XS_MAX: WEB_BREAKPOINT_START_NUMBERS.SM - 1,
    SM_MIN: WEB_BREAKPOINT_START_NUMBERS.SM,
    SM_MAX: WEB_BREAKPOINT_START_NUMBERS.MD - 1,
    MD_MIN: WEB_BREAKPOINT_START_NUMBERS.MD,
    MD_MAX: WEB_BREAKPOINT_START_NUMBERS.LG - 1,
    LG_MIN: WEB_BREAKPOINT_START_NUMBERS.LG,
    LG_MAX: WEB_BREAKPOINT_START_NUMBERS.XL - 1,
    XL_MIN: WEB_BREAKPOINT_START_NUMBERS.XL,
    // XL has no MAX on web
};
export const NATIVE_BREAKPOINT = {
    SM_MIN: NATIVE_BREAKPOINT_START_NUMBERS.SM,
    SM_MAX: NATIVE_BREAKPOINT_START_NUMBERS.MD - 1,
    MD_MIN: NATIVE_BREAKPOINT_START_NUMBERS.MD,
    MD_MAX: NATIVE_BREAKPOINT_START_NUMBERS.LG - 1,
    LG_MIN: NATIVE_BREAKPOINT_START_NUMBERS.LG,
    // LG has not MAX on native
};
//
// For responsive adjustments we define CSS media queries ranges.
//   - We provide a narrow, specific range for targetting only a given device with `v`
//   - We provide a "mobile first" min-width range for each breakpoint for simplest use as just `v-up`
//   - We provide options for broader ranges as needed beginning with small range and up to (just shy of) another range with `v1-to-v2`
//
//
// Web uses CSS media queries that are intended to be used in styled components or with the matchMedia API.
//
export const WEB_BREAKPOINT_QUERIES = {
    xs: `(max-width: ${WEB_BREAKPOINT.XS_MAX}px)`,
    'xs-to-md': `(max-width: ${WEB_BREAKPOINT.SM_MAX}px)`,
    'xs-to-lg': `(max-width: ${WEB_BREAKPOINT.MD_MAX}px)`,
    'xs-to-xl': `(max-width: ${WEB_BREAKPOINT.LG_MAX}px)`,
    'xs-up': `(min-width: ${WEB_BREAKPOINT.XS_MIN}px)`,
    sm: `(min-width: ${WEB_BREAKPOINT.SM_MIN}px) and (max-width: ${WEB_BREAKPOINT.SM_MAX}px)`,
    'sm-to-lg': `(min-width: ${WEB_BREAKPOINT.SM_MIN}px) and (max-width: ${WEB_BREAKPOINT.MD_MAX}px)`,
    'sm-to-xl': `(min-width: ${WEB_BREAKPOINT.SM_MIN}px) and (max-width: ${WEB_BREAKPOINT.LG_MAX}px)`,
    'sm-up': `(min-width: ${WEB_BREAKPOINT.SM_MIN}px)`,
    md: `(min-width: ${WEB_BREAKPOINT.MD_MIN}px) and (max-width: ${WEB_BREAKPOINT.MD_MAX}px)`,
    'md-to-xl': `(min-width: ${WEB_BREAKPOINT.MD_MIN}px) and (max-width: ${WEB_BREAKPOINT.LG_MAX}px)`,
    'md-up': `(min-width: ${WEB_BREAKPOINT.MD_MIN}px)`,
    lg: `(min-width: ${WEB_BREAKPOINT.LG_MIN}px) and (max-width: ${WEB_BREAKPOINT.LG_MAX}px)`,
    'lg-up': `(min-width: ${WEB_BREAKPOINT.LG_MIN}px)`,
    xl: `(min-width: ${WEB_BREAKPOINT.XL_MIN}px)`,
};
//
// Native uses functions to which the current device width can be passed to evaluate it on a range
//
export const NATIVE_BREAKPOINT_QUERIES = {
    sm: (width) => width >= NATIVE_BREAKPOINT.SM_MIN && width <= NATIVE_BREAKPOINT.SM_MAX,
    'sm-to-lg': (width) => width >= NATIVE_BREAKPOINT.SM_MIN && width <= NATIVE_BREAKPOINT.SM_MAX,
    'sm-up': (width) => width >= NATIVE_BREAKPOINT.SM_MIN,
    md: (width) => width >= NATIVE_BREAKPOINT.MD_MIN && width <= NATIVE_BREAKPOINT.MD_MAX,
    'md-up': (width) => width >= NATIVE_BREAKPOINT.MD_MIN,
    lg: (width) => width >= NATIVE_BREAKPOINT.LG_MIN,
};
